<template>
  <div class="form-color-picker" :class="{ 'opacity-50': disabled }">
    <div class="handle"
         :class="{open: open}"
         @click="toggle"
    >
      <div class="rounded-lg" style="width:30px; height:30px; display:inline-block; vertical-align: middle;"
           :style="{'background-color': value}"></div>
    </div>
    <Sketch
      v-if="open"
      :value="value"
      :allow-custom="false"
      :preset-colors="presetColors"
      @input="handleChange"
      @close="close"
    />
  </div>
</template>

<script>
  import Sketch from '@/_legacy/components/Controls/ColorPicker/components/Sketch.vue';

  export default {

    components: { Sketch },

    props: {
      value: {
        type: String,
        default: '#000000',
      },
      disabled: Boolean,
    },

    data: () => ({
      open: false,
      presetColors: [
        '#00C389', '#FFAD22', '#FD2F58', '#777777',
        '#00B2FF', '#8D5FD6', '#1BE7FF', '#FF49DB',
        '#4474FF', '#60D956', '#FF6E44', '#60D2C9',
      ],
    }),

    methods: {
      handleChange(value) {
        this.$emit('input', value.hex);
      },
      toggle() {
        if (this.disabled) {
          return;
        }

        this.open = !this.open;
      },
      close() {
        this.open = false;
      },
    },

  };

</script>
